class ComponentSorting extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      groupSort: this.querySelector(".group-sort") ? this.querySelector(".group-sort") : null,
      timeEffectSort: null,
    };

    this.init();
  }

  init() {
    if(this.elements.groupSort) {
      this.elements.groupSort.addEventListener("mouseleave", this._closeSort.bind(this));
      this.elements.groupSort.addEventListener("mouseenter", this.displaySort.bind(this));
    }
  }

  displaySort() {
    let _ref_bodySort = this.elements.groupSort;

    if (!this.elements.groupSort.classList.contains("active")) {
      _ref_bodySort.classList.add("active");
      this.elements.timeEffectSort = setTimeout(() => {
        _ref_bodySort.classList.add("active-effect");
      }, 10);
    } else {
      this._closeSort();
    }
  }

  _closeSort() {
    let _ref_bodySort = this.elements.groupSort;

    _ref_bodySort.classList.remove("active-effect");
    this.elements.timeEffectSort = setTimeout(() => {
      _ref_bodySort.classList.remove("active");
    }, 200);
  }
}

customElements.define("component-sorting", ComponentSorting);
